export { default } from './OutsideClickedWrapper';
